import client from 'client';

export async function declineCallApi(eventId: number, meetingId: string) {
    return await client().post(`/api/v2/meetings/events/${eventId}/meetings/${meetingId}/decline`);
}

type JoinResponse = {
    id: string;
    meetingChannel: {
        type: string;
        subtype: string;
        channelId: string;
        token: string;
        uid: string;
        streamId: string;
    };
};

export async function joinChannelApi(eventId: number, meetingId: string) {
    const res = await client().post<JoinResponse>(
        `/api/v2/meetings/events/${eventId}/meetings/${meetingId}/access`
    );
    return res.data;
}
